/**
 * The platform's copyright warning, laid out like a portal's own text: the
 * dialog title on the first line, then one line per paragraph.
 */
export const getPlatformCopyrightMessage = (t) => [
    t("Copyrighted work"),
    t("This work represents our time, effort and creativity."),
    t("Please show integrity and respect by not copying or sharing it without permission."),
].join("\n");
/**
 * The platform's copyright acknowledgement, shown before the first preview.
 * Bump WebshopCopyrightAcknowledgement::PLATFORM_TEXT_VERSION when changing
 * it, so browsers that accepted the old text are asked again.
 */
export const getPlatformCopyrightAcknowledgement = (t) => [
    t("Copyrighted work"),
    t("I understand that the pictures I’m about to view are protected by copyright."),
    t("I agree not to copy or screenshot them."),
].join("\n");
/** What the portal shows with no text of its own: the group's, else the platform's. */
export const getInheritedCopyrightMessage = (message, platform) => (message === null || message === void 0 ? void 0 : message.group) || platform || "";
/** What the webshop shows: the portal's own text, else the inherited one. */
export const getShownCopyrightMessage = (message, platform) => (message === null || message === void 0 ? void 0 : message.own) || getInheritedCopyrightMessage(message, platform);
export const parseCopyrightMessage = (message) => {
    const [title = "", ...paragraphs] = message
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter((line) => line !== "");
    return { title, paragraphs };
};
/** The text as the server stores it, for telling an edit from no change. */
export const normalizeCopyrightMessage = (message) => {
    const { title, paragraphs } = parseCopyrightMessage(message);
    return [title, ...paragraphs].filter((line) => line !== "").join("\n");
};
